import React from 'react';
import { Form, Button, Icon } from 'semantic-ui-react';
import { Field } from 'formik';
import moment from 'moment';

class InformationSheetForm extends React.Component<any, any> {
  private lis = new Array<HTMLElement>(1);

  handleShow = (i: number) => {
    this.lis[i].scrollIntoView({ block: 'end', behavior: 'smooth' });
  };

  prev = (e: any) => {
    e.preventDefault();
    this.props.prevStep();
  };

  next = (e: any) => {
    e.preventDefault();
    this.props.setFieldValue('stp6_infoSheetRead', true);
    this.props.setFieldValue(
      'stp6_infoSheetReadTS',
      moment().format('DD/MM/YYYY, HH:mm:ss')
    );
    setTimeout(() => {
      this.props.gaEvent('event', 'ReadSummary', 'Read', 'Boots', this.props.isValid);
      this.props.nextStep(this.props);
    }, 150);
  };

  renderScrollBtn(direction: string) {
    return (
      <div style={{ textAlign: 'center' }}>
        <Button
          onClick={(e) => {
            this.handleShow(0)
          }}
          style={{ borderBottom: "solid 3px #209639" }}
          circular
          positive
          icon
          size="big"
          data-testid={`dba-button-scroll-${direction}`}
        >
          <Icon
            style={{ textShadow: "1px -1px #888888, 1px -3px #209639" }}
            size="big"
            name={direction === 'up' ? 'arrow up': 'arrow down'}
          />
        </Button>
        <p style={{ fontSize: '20px', color: 'black' }}>Scroll to Accept</p>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderScrollBtn('down')}
        <Form.Group grouped>
          <h3 className="ui header" style={{ textAlign: 'left' }}>
            Your Information Sheet
          </h3>

          <p>
            Before you join the claim, you should understand the arrangements with your solicitors.
            The Information sheet below is a summary of your legal document. When you click next, a
            document pack will appear. The document pack sets out:
          </p>

          <p>
            &bull; Your no-win, no-fee agreement with Roscoe Reid (your solicitors).
          </p>

          <p>Here is a summary of the document pack:</p>

          <div
            id="xxxxSummary"
            style={{
              overflow: 'scroll',
              width: '100%',
              maxHeight: '450px',
              boxShadow:
                '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
              margin: '10px auto'
            }}
          >
            <img
              style={{ width: '100%' }}
              src="https://documents-pj.s3.eu-west-2.amazonaws.com/boots-info-sheet-pg1.png"
              alt="information sheet"
            />
            <img
              style={{ width: '100%' }}
              src="https://documents-pj.s3.eu-west-2.amazonaws.com/boots-info-sheet-pg2.png"
              alt="information sheet"
            />
            <img
              style={{ width: '100%' }}
              src="https://documents-pj.s3.eu-west-2.amazonaws.com/boots-info-sheet-pg3.png"
              alt="information sheet"
            />
          </div>

          <Field type="hidden" name="stp6_infoSheetRead" value={false} />
          <Field type="hidden" name="stp6_infoSheetReadTS" value="" />

          <Button.Group widths="2" style={{ margin: '10px auto' }}>
            <Button
              labelPosition="right"
              color={this.props.isValid ? 'green' : 'grey'}
              icon="right chevron"
              content={
                <div>
                  I’ve read the summary. <br /> Show me the document pack.
                </div>
              }
              onClick={this.next}
              data-testid="infosheet-button-next"
            />
          </Button.Group>
        </Form.Group>

        <div
          style={{ lineHeight: '200px' }}
          ref={li => (this.lis[0] = li!)}
          data-testid="infosheet-div-scrollIntoView"
        />
        
      </React.Fragment>
    );
  }
}

export default InformationSheetForm;
